/**************
 Global
 ***************/

// url search params
const urlParams = new URLSearchParams(window.location.search);

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            if (data.status !== 200) {
                return false;
            }

            return data.json();
        })
}


//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

// clear cart
function clearCart() {
    return fetch('/cart/clear.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


/*******************
 Smooth Scroll
 *******************/

if (urlParams.get("scroll_to")) {
    const element = document.querySelector(urlParams.get("scroll_to"));
    if (element) {
        // remove from url
        history.replaceState(null, null, window.location.pathname);

        // scroll to element
        sleep(100)
            .then(function () {
                window.scrollTo({
                    behavior: 'smooth',
                    top: element.offsetTop - 50
                })
            });
    }
}


/*******************
 Tutorial JS
 *******************/

if (urlParams.has('premium') === true) {
    // set local storage
    localStorage.setItem('premium', "true");
}

/*******************
 Close video popup
 *******************/
document.querySelectorAll(".videoPopup")?.forEach(element => {
    element.addEventListener('close', function () {
        element.close();
        element.querySelector("video")?.pause();
    });

    // Close on click outside
    element.addEventListener("click", function (event) {
        if (event.target === element) {
            element.close();
        }
    });

    // Close on click close button
    element.querySelector(".videoPopupClose").addEventListener("click", function () {
        element.close();
    });
});

// global function to determine if they have tutorial access
async function hasTutorialAccess() {
    return localStorage.getItem("tutorial_access") === "true";
}


/*******************
 Checkout Champs
 *******************/
document.addEventListener("DOMContentLoaded", function () {
    let URL = window.location.href;
    let params = new URLSearchParams(window.location.search);

    // var debug = console.log.bind(console, '[DEBUG][RedirectCart]');

    // If we're on the Vibit PDP and the URL Params include champs=true
    if (URL.includes('/products/the-vibit') && params.has('champs') && params.get('champs') === 'true') {
        // debug('Correct URL, script loaded');

        window.RedirectCart = function (options) {
            var self = {};

            function getCartCookie(name) {
                var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                return match ? match[2] : null;
            }

            function getCheckoutURL(data) {
                let cookie = getCartCookie('cart');
                let affId = getCartCookie('affId'); // Get affiliate ID if available

                let urlLineItems = Object.keys(data.meta_product_id_array).map(productId =>
                    `${data.meta_product_id_array[productId].id}:${data.meta_product_id_array[productId].quantity}`
                ).join(';');

                let checkoutUrl = self.options.checkoutUrl + `?products=${urlLineItems}&cartId=${cookie}`;
                if (affId) checkoutUrl += `&affId=${affId}`;

                // debug('Generated Checkout URL:', checkoutUrl);
                return checkoutUrl;
            }

            function checkout(event) {
                event.preventDefault();
                event.stopPropagation();

                fetch('/cart?view=meta-data.json')
                    .then(response => response.json())
                    .then(data => {
                        let checkoutUrl = getCheckoutURL(data);
                        // debug('Redirecting to:', checkoutUrl);
                        window.location.href = checkoutUrl;
                    })
                    .catch(error => console.error('Error fetching cart data:', error));
            }

            function init() {
                self.options = Object.assign({
                    checkoutButtonSelector: '#miniCartFooterCheckout', // Update button selector
                    checkoutUrl: 'https://go.vibitus.com/Vibit-roll-checkout' // Replace with your actual checkout URL
                }, options);

                let checkoutButton = document.querySelector(self.options.checkoutButtonSelector);
                if (checkoutButton) {
                    checkoutButton.addEventListener('click', checkout, true);
                    // debug('Checkout button event attached');
                } else {
                    // debug('Checkout button not found!');
                }
            }

            init();
            return self;
        };

        var instance = new RedirectCart();

    } else {
        // debug('URL does not match, script not applied');
    }
});


// LP Pages
let lpPages = [
    '/pages/facebook',
    '/pages/quiz-shopify',
    '/pages/native-shopify',
    '/pages/facebook-shopify',
    '/pages/youtube-shopify',
    '/pages/vibit-roll-native',
    '/pages/vibit-roll-meta',
    '/pages/vibit-roll-yt',
    '/pages/youtube-offer',
    '/pages/native-cc',
    '/pages/quiz-cc'
]

// if we are on a LP page, load the pixel
if (lpPages.includes(window.location.pathname)) {
    (async function () {

        // download the vibit roll product
        let rollProduct = await downloadProduct('the-vibit');
        try {
            window._upstack && window._upstack('track', 'view_content',
                {
                    value: rollProduct.price / 100,
                    currency: 'USD',
                    items: [{
                        id: rollProduct.id,
                        quantity: 1,
                        name: rollProduct.title,
                        price: rollProduct.price / 100,
                    }]
                })
        } catch (e) {
            console.log(e);
        }
    }())
}